module.exports = __webpack_public_path__ + "img/EDC5000AQ_R.84b322e7.png";